import Q from "../../@babel/runtime/helpers/esm/extends.mjs";
import X from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import W from "../../@babel/runtime/helpers/esm/regeneratorRuntime.mjs";
import Y from "../../@babel/runtime/helpers/esm/asyncToGenerator.mjs";
import _ from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import U from "../../@babel/runtime/helpers/esm/toConsumableArray.mjs";
import Z from "../../@babel/runtime/helpers/esm/classCallCheck.mjs";
import ee from "../../@babel/runtime/helpers/esm/createClass.mjs";
import a from "../../@babel/runtime/helpers/esm/assertThisInitialized.mjs";
import te from "../../@babel/runtime/helpers/esm/inherits.mjs";
import re from "../../@babel/runtime/helpers/esm/createSuper.mjs";
import i from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import ne from "../../rc-util/es/Children/toArray.mjs";
import G from "../../rc-util/es/isEqual.mjs";
import q from "../../rc-util/es/warning.mjs";
import * as k from "react";
import J, { HOOK_MARK as A } from "./FieldContext.mjs";
import ie from "./ListContext.mjs";
import { toArray as B } from "./utils/typeUtil.mjs";
import { validateRules as ae } from "./utils/validateUtil.mjs";
import { getNamePath as z, containsNamePath as S, defaultGetValueFromEvent as oe } from "./utils/valueUtil.mjs";
import le from "../../rc-util/es/utils/get.mjs";
var se = ["name"], h = [];
function j(O, I, f, v, e, d) {
  return typeof O == "function" ? O(I, f, "source" in d ? {
    source: d.source
  } : {}) : v !== e;
}
var K = /* @__PURE__ */ function(O) {
  te(f, O);
  var I = re(f);
  function f(v) {
    var e;
    if (Z(this, f), e = I.call(this, v), i(a(e), "state", {
      resetCount: 0
    }), i(a(e), "cancelRegisterFunc", null), i(a(e), "mounted", !1), i(a(e), "touched", !1), i(a(e), "dirty", !1), i(a(e), "validatePromise", void 0), i(a(e), "prevValidating", void 0), i(a(e), "errors", h), i(a(e), "warnings", h), i(a(e), "cancelRegister", function() {
      var t = e.props, r = t.preserve, n = t.isListField, l = t.name;
      e.cancelRegisterFunc && e.cancelRegisterFunc(n, r, z(l)), e.cancelRegisterFunc = null;
    }), i(a(e), "getNamePath", function() {
      var t = e.props, r = t.name, n = t.fieldContext, l = n.prefixName, o = l === void 0 ? [] : l;
      return r !== void 0 ? [].concat(U(o), U(r)) : [];
    }), i(a(e), "getRules", function() {
      var t = e.props, r = t.rules, n = r === void 0 ? [] : r, l = t.fieldContext;
      return n.map(function(o) {
        return typeof o == "function" ? o(l) : o;
      });
    }), i(a(e), "refresh", function() {
      e.mounted && e.setState(function(t) {
        var r = t.resetCount;
        return {
          resetCount: r + 1
        };
      });
    }), i(a(e), "metaCache", null), i(a(e), "triggerMetaEvent", function(t) {
      var r = e.props.onMetaChange;
      if (r) {
        var n = _(_({}, e.getMeta()), {}, {
          destroy: t
        });
        G(e.metaCache, n) || r(n), e.metaCache = n;
      } else
        e.metaCache = null;
    }), i(a(e), "onStoreChange", function(t, r, n) {
      var l = e.props, o = l.shouldUpdate, E = l.dependencies, L = E === void 0 ? [] : E, y = l.onReset, x = n.store, p = e.getNamePath(), F = e.getValue(t), P = e.getValue(x), w = r && S(r, p);
      switch (n.type === "valueUpdate" && n.source === "external" && !G(F, P) && (e.touched = !0, e.dirty = !0, e.validatePromise = null, e.errors = h, e.warnings = h, e.triggerMetaEvent()), n.type) {
        case "reset":
          if (!r || w) {
            e.touched = !1, e.dirty = !1, e.validatePromise = void 0, e.errors = h, e.warnings = h, e.triggerMetaEvent(), y == null || y(), e.refresh();
            return;
          }
          break;
        case "remove": {
          if (o && j(o, t, x, F, P, n)) {
            e.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var s = n.data;
          if (w) {
            "touched" in s && (e.touched = s.touched), "validating" in s && !("originRCField" in s) && (e.validatePromise = s.validating ? Promise.resolve([]) : null), "errors" in s && (e.errors = s.errors || h), "warnings" in s && (e.warnings = s.warnings || h), e.dirty = !0, e.triggerMetaEvent(), e.reRender();
            return;
          } else if ("value" in s && S(r, p, !0)) {
            e.reRender();
            return;
          }
          if (o && !p.length && j(o, t, x, F, P, n)) {
            e.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var N = L.map(z);
          if (N.some(function(b) {
            return S(n.relatedFields, b);
          })) {
            e.reRender();
            return;
          }
          break;
        }
        default:
          if (w || (!L.length || p.length || o) && j(o, t, x, F, P, n)) {
            e.reRender();
            return;
          }
          break;
      }
      o === !0 && e.reRender();
    }), i(a(e), "validateRules", function(t) {
      var r = e.getNamePath(), n = e.getValue(), l = t || {}, o = l.triggerName, E = l.validateOnly, L = E === void 0 ? !1 : E, y = Promise.resolve().then(/* @__PURE__ */ Y(/* @__PURE__ */ W().mark(function x() {
        var p, F, P, w, s, N, b;
        return W().wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                if (e.mounted) {
                  m.next = 2;
                  break;
                }
                return m.abrupt("return", []);
              case 2:
                if (p = e.props, F = p.validateFirst, P = F === void 0 ? !1 : F, w = p.messageVariables, s = p.validateDebounce, N = e.getRules(), o && (N = N.filter(function(g) {
                  return g;
                }).filter(function(g) {
                  var R = g.validateTrigger;
                  if (!R)
                    return !0;
                  var C = B(R);
                  return C.includes(o);
                })), !(s && o)) {
                  m.next = 10;
                  break;
                }
                return m.next = 8, new Promise(function(g) {
                  setTimeout(g, s);
                });
              case 8:
                if (e.validatePromise === y) {
                  m.next = 10;
                  break;
                }
                return m.abrupt("return", []);
              case 10:
                return b = ae(r, n, N, t, P, w), b.catch(function(g) {
                  return g;
                }).then(function() {
                  var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : h;
                  if (e.validatePromise === y) {
                    var R;
                    e.validatePromise = null;
                    var C = [], $ = [];
                    (R = g.forEach) === null || R === void 0 || R.call(g, function(H) {
                      var u = H.rule.warningOnly, M = H.errors, V = M === void 0 ? h : M;
                      u ? $.push.apply($, U(V)) : C.push.apply(C, U(V));
                    }), e.errors = C, e.warnings = $, e.triggerMetaEvent(), e.reRender();
                  }
                }), m.abrupt("return", b);
              case 13:
              case "end":
                return m.stop();
            }
        }, x);
      })));
      return L || (e.validatePromise = y, e.dirty = !0, e.errors = h, e.warnings = h, e.triggerMetaEvent(), e.reRender()), y;
    }), i(a(e), "isFieldValidating", function() {
      return !!e.validatePromise;
    }), i(a(e), "isFieldTouched", function() {
      return e.touched;
    }), i(a(e), "isFieldDirty", function() {
      if (e.dirty || e.props.initialValue !== void 0)
        return !0;
      var t = e.props.fieldContext, r = t.getInternalHooks(A), n = r.getInitialValue;
      return n(e.getNamePath()) !== void 0;
    }), i(a(e), "getErrors", function() {
      return e.errors;
    }), i(a(e), "getWarnings", function() {
      return e.warnings;
    }), i(a(e), "isListField", function() {
      return e.props.isListField;
    }), i(a(e), "isList", function() {
      return e.props.isList;
    }), i(a(e), "isPreserve", function() {
      return e.props.preserve;
    }), i(a(e), "getMeta", function() {
      e.prevValidating = e.isFieldValidating();
      var t = {
        touched: e.isFieldTouched(),
        validating: e.prevValidating,
        errors: e.errors,
        warnings: e.warnings,
        name: e.getNamePath(),
        validated: e.validatePromise === null
      };
      return t;
    }), i(a(e), "getOnlyChild", function(t) {
      if (typeof t == "function") {
        var r = e.getMeta();
        return _(_({}, e.getOnlyChild(t(e.getControlled(), r, e.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var n = ne(t);
      return n.length !== 1 || !/* @__PURE__ */ k.isValidElement(n[0]) ? {
        child: n,
        isFunction: !1
      } : {
        child: n[0],
        isFunction: !1
      };
    }), i(a(e), "getValue", function(t) {
      var r = e.props.fieldContext.getFieldsValue, n = e.getNamePath();
      return le(t || r(!0), n);
    }), i(a(e), "getControlled", function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.props, n = r.name, l = r.trigger, o = r.validateTrigger, E = r.getValueFromEvent, L = r.normalize, y = r.valuePropName, x = r.getValueProps, p = r.fieldContext, F = o !== void 0 ? o : p.validateTrigger, P = e.getNamePath(), w = p.getInternalHooks, s = p.getFieldsValue, N = w(A), b = N.dispatch, m = e.getValue(), g = x || function(u) {
        return i({}, y, u);
      }, R = t[l], C = n !== void 0 ? g(m) : {};
      process.env.NODE_ENV !== "production" && C && Object.keys(C).forEach(function(u) {
        q(typeof C[u] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(u, ")"));
      });
      var $ = _(_({}, t), C);
      $[l] = function() {
        e.touched = !0, e.dirty = !0, e.triggerMetaEvent();
        for (var u, M = arguments.length, V = new Array(M), T = 0; T < M; T++)
          V[T] = arguments[T];
        E ? u = E.apply(void 0, V) : u = oe.apply(void 0, [y].concat(V)), L && (u = L(u, m, s(!0))), b({
          type: "updateValue",
          namePath: P,
          value: u
        }), R && R.apply(void 0, V);
      };
      var H = B(F || []);
      return H.forEach(function(u) {
        var M = $[u];
        $[u] = function() {
          M && M.apply(void 0, arguments);
          var V = e.props.rules;
          V && V.length && b({
            type: "validateField",
            namePath: P,
            triggerName: u
          });
        };
      }), $;
    }), v.fieldContext) {
      var d = v.fieldContext.getInternalHooks, c = d(A), D = c.initEntityValue;
      D(a(e));
    }
    return e;
  }
  return ee(f, [{
    key: "componentDidMount",
    value: function() {
      var v = this.props, e = v.shouldUpdate, d = v.fieldContext;
      if (this.mounted = !0, d) {
        var c = d.getInternalHooks, D = c(A), t = D.registerField;
        this.cancelRegisterFunc = t(this);
      }
      e === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var v = this.state.resetCount, e = this.props.children, d = this.getOnlyChild(e), c = d.child, D = d.isFunction, t;
      return D ? t = c : /* @__PURE__ */ k.isValidElement(c) ? t = /* @__PURE__ */ k.cloneElement(c, this.getControlled(c.props)) : (q(!c, "`children` of Field is not validate ReactElement."), t = c), /* @__PURE__ */ k.createElement(k.Fragment, {
        key: v
      }, t);
    }
  }]), f;
}(k.Component);
i(K, "contextType", J);
i(K, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function $e(O) {
  var I = O.name, f = X(O, se), v = k.useContext(J), e = k.useContext(ie), d = I !== void 0 ? z(I) : void 0, c = "keep";
  return f.isListField || (c = "_".concat((d || []).join("_"))), process.env.NODE_ENV !== "production" && f.preserve === !1 && f.isListField && d.length <= 1 && q(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ k.createElement(K, Q({
    key: c,
    name: d,
    isListField: !!e
  }, f, {
    fieldContext: v
  }));
}
export {
  $e as default
};
//# sourceMappingURL=Field.mjs.map
